import { Box, Skeleton } from "@mui/material";

export const SkeletonActivityItemProfile = () => {
  return (
    <>
      <Skeleton height={40} />
      <Skeleton height={40} />
      <Box display="flex" gap={2}>
        <Skeleton width={120} height={80}/>
        <Skeleton width={120} height={80} />
        <Skeleton width={120} height={80}/>
        <Skeleton width={120} height={80} />
      </Box>
      <Skeleton height={300} />
    </>
  );
};
